import React, { useEffect } from "react";

import Page from "src/components/Page";
import { storage } from "./utils";
import Home from "./Home";

// Wording taken from the site's existing homepage SEO copy (previous Home.js meta payload).
const PAGE_TITLE = "Leon Gallery | Premier Philippine Art Gallery & Auction House";
const PAGE_DESCRIPTION =
  "Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions.";

function Index() {
  // Clear any lot selection left over from a previous auction page. (Unchanged.)
  useEffect(() => {
    storage.remove("@storeAuctionLot");
  }, []);

  return (
    <Page title={PAGE_TITLE} description={PAGE_DESCRIPTION}>
      <Home />
    </Page>
  );
}

export default Index;
